
import type { GetMilestoneParams } from '@/store/api/milestoneApi';
import type { Milestone, MilestoneSteps } from '@/types';

import {
  useCreateMilestoneMutation,
  useDeleteMilestoneMutation,
  useGetMilestoneQuery,
  useGetMilestonesQuery,
  useUpdateMilestoneMutation,
} from '@/store/api/milestoneApi';

const mockMilestone = { steps: [] } as unknown as Milestone;

export const useGetMilestones = () => {
  const result = useGetMilestonesQuery();
  return {
    ...result,
    data: result.data || ({ other: [], own: {} } as unknown as MilestoneSteps),
  };
};

export const useGetMilestone = (params: GetMilestoneParams) => {
  const result = useGetMilestoneQuery(params);
  return {
    ...result,
    data: result.data || mockMilestone,
  };
};

export const useUpdateMilestone = () => {
  const [trigger, result] = useUpdateMilestoneMutation();
  return {
    mutate: (
      variables: Parameters<typeof trigger>[0], 
      options?: { 
        onSuccess?: (data: Milestone) => void; 
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      trigger(variables)
        .unwrap()
        .then((data) => {
          options?.onSuccess?.(data);
          options?.onSettled?.();
        })
        .catch((error) => {
          options?.onError?.(error);
          options?.onSettled?.();
        });
    },
    ...result,
  };
};

export const useCreateMilestone = () => {
  const [trigger, result] = useCreateMilestoneMutation();
  return {
    mutate: (
      variables: Parameters<typeof trigger>[0], 
      options?: { 
        onSuccess?: (data: Milestone) => void; 
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      trigger(variables)
        .unwrap()
        .then((data) => {
          options?.onSuccess?.(data);
          options?.onSettled?.();
        })
        .catch((error) => {
          options?.onError?.(error);
          options?.onSettled?.();
        });
    },
    ...result,
  };
};

export const useDeleteMilestone = () => {
  const [trigger, result] = useDeleteMilestoneMutation();
  return {
    mutate: (
      variables: Parameters<typeof trigger>[0], 
      options?: { 
        onSuccess?: (data: void) => void; 
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      trigger(variables)
        .unwrap()
        .then((data) => {
          options?.onSuccess?.(data);
          options?.onSettled?.();
        })
        .catch((error) => {
          options?.onError?.(error);
          options?.onSettled?.();
        });
    },
    ...result,
  };
};
